import Joi from "joi";

export const applicationSchema = Joi.object({
  sName: Joi.string().trim().required().messages({
    "string.base": "Application Name must be a string.",
    "string.empty": "Application Name is required.",
    "any.required": "Application Name is required.",
  }),
  sDescription: Joi.string().trim().messages({
    "string.base": "Application Description must be a string.",
    "string.empty": "Application Description is required.",
    "any.required": "Application Description is required.",
  }),
});
